import { motion } from 'framer-motion';

const rules = [
  { icon: '👀', title: 'Vuxen övervakning', text: 'En vuxen ska alltid övervaka leken.' },
  { icon: '⚓', title: 'Förankring obligatorisk', text: 'Hoppborgen ska alltid förankras enligt anvisning.' },
  { icon: '👥', title: 'Max antal användare', text: 'Följ max-antalet som anges på borgen.' },
  { icon: '🚫', title: 'Inga skor eller vassa föremål', text: 'Skor, smycken och vassa föremål lämnas utanför.' },
  { icon: '💨', title: 'Ej vid stark vind', text: 'Stäng av användning vid vindar över 8 m/s.' },
];

export default function Safety() {
  return (
    <section id="sakerhet" className="relative py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-[2.5rem] bg-gradient-to-br from-sun via-sun to-tomato p-8 sm:p-12 lg:p-16 overflow-hidden grain">
          <div className="absolute -top-16 -right-16 size-64 rounded-full bg-cream/40 blur-3xl" />
          <div className="absolute -bottom-20 -left-10 size-72 rounded-full bg-grape/30 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
              <div className="inline-flex items-center gap-2 rounded-full bg-ink text-cream px-3 py-1 text-xs font-semibold uppercase tracking-wider">
                <span>🛡️</span> Säkerhet först
              </div>
              <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.02] text-balance">
                Trygg lek börjar med <span className="underline decoration-tomato decoration-[6px] underline-offset-8">rätt rutiner</span>.
              </h2>
              <p className="mt-5 text-ink/80 text-lg max-w-md">
                Alla våra produkter uppfyller den europeiska säkerhetsstandarden{' '}
                <span className="font-semibold">SS-EN 14960</span> — och vi går igenom säker användning vid varje leverans.
              </p>
              <div className="mt-8 inline-flex items-center gap-3 rounded-full bg-cream px-5 py-3 shadow-pop">
                <span className="size-9 grid place-items-center rounded-full bg-grass text-cream">✓</span>
                <div>
                  <div className="text-sm font-semibold leading-tight">Certifierade & försäkrade</div>
                  <div className="text-xs text-ink/60">SS-EN 14960 · Tillverkat i Europa</div>
                </div>
              </div>
              <div className="mt-5">
                <a
                  href="/sakerhet"
                  className="inline-flex items-center gap-2 text-sm font-semibold text-ink underline-offset-4 hover:underline"
                >
                  Läs mer om vårt säkerhetsarbete <span aria-hidden className="transition-transform hover:translate-x-1">→</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-7">
              <ul className="grid sm:grid-cols-2 gap-3">
                {rules.map((r, i) => (
                  <motion.li
                    key={r.title}
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.07 }}
                    whileHover={{ y: -4 }}
                    className="flex gap-4 rounded-2xl bg-cream/95 backdrop-blur border border-ink/5 p-5 shadow-[0_6px_18px_-10px_rgba(15,27,45,0.3)]"
                  >
                    <span className="size-12 shrink-0 grid place-items-center rounded-2xl bg-ink text-cream text-xl">
                      {r.icon}
                    </span>
                    <div>
                      <div className="font-display text-lg font-semibold leading-tight">{r.title}</div>
                      <div className="mt-1 text-sm text-ink/65">{r.text}</div>
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
